var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
const broadcastFetcher = fetcher.path("/api/notifications/broadcast/{notification_id}").method("get").create();
export function fetchBroadcast(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield broadcastFetcher({ notification_id: id });
        return data;
    });
}
const broadcastsFetcher = fetcher.path("/api/notifications/broadcast").method("get").create();
export function fetchAllBroadcasts() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield broadcastsFetcher({});
        return data;
    });
}
const postBroadcast = fetcher.path("/api/notifications/broadcast").method("post").create();
export function createBroadcast(broadcast) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield postBroadcast(broadcast);
        return data;
    });
}
const putBroadcast = fetcher.path("/api/notifications/broadcast/{notification_id}").method("put").create();
export function updateBroadcast(id, broadcast) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield putBroadcast(Object.assign({ notification_id: id }, broadcast));
        return data;
    });
}
